import { useState } from 'react';
import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Col,
} from "reactstrap";
import classnames from "classnames";
import CustomCode from '../../../Util/Code/CustomCode';
import ClusterMap from '../../../Util/Map/ClusterMap'

const coords = [
  { lat: -23.533564212639348, lng: -46.66153639661013, description: <h3>teste</h3> },
  {
    lat: -23.606238519004243,
    lng: -46.62976633426616,
    description: (
      <div>
        <p>
          <strong>titulo</strong>
        </p>
        <span>teste</span>
      </div>)
  },
  { lat: -23.586701376686392, lng: -46.690811957660266, description: 'Ponto 3' },
  { lat: -23.47290133823533, lng: -46.71604740419262, description: 'Ponto 4' },
  { lat: -23.525568909411827, lng: -46.74554417205502, description: 'Ponto 5' },
  { lat: -23.53274258603608, lng: -46.74300933408579, description: 'Ponto 6' },
  { lat: -23.46148612537836, lng: -46.667414722338194, description: 'Ponto 7' },
  { lat: -23.595981159461207, lng: -46.66192963491876, description: 'Ponto 8' },
  { lat: -23.496517105522404, lng: -46.63169561946284, description: 'Ponto 9' },
  { lat: -23.58561273827321, lng: -46.60206375174043, description: 'Ponto 10' },
  { lat: -23.49596120332361, lng: -46.61108579624811, description: 'Ponto 11' },
  { lat: -23.42911597649735, lng: -46.713792052882894, description: 'Ponto 12' },
  { lat: -23.619689527715856, lng: -46.751845296194986, description: 'Ponto 13' },
  { lat: -23.582850355106327, lng: -46.544465209700085, description: 'Ponto 14' },
  { lat: -23.463673189713045, lng: -46.66040865558177, description: 'Ponto 15' }
];

function ComponentExample() {

  const [activeTab, setActiveTab] = useState('component');

  const codeString = `
      // Exemplo de uso 
      <ClusterMap coords={coords} zoomLevel={11} />

      // coords
      const coords = [
        { lat: -23.533564212639348, lng: -46.66153639661013, description: <h3>teste</h3> },
        {
          lat: -23.606238519004243,
          lng: -46.62976633426616,
          description: (
            <div>
              <p>
                <strong>titulo</strong>
              </p>
              <span>teste</span>
            </div>)
        },
        { lat: -23.586701376686392, lng: -46.690811957660266, description: 'Ponto 3' },
        { lat: -23.47290133823533, lng: -46.71604740419262, description: 'Ponto 4' },
        { lat: -23.525568909411827, lng: -46.74554417205502, description: 'Ponto 5' },
        { lat: -23.53274258603608, lng: -46.74300933408579, description: 'Ponto 6' },
        { lat: -23.46148612537836, lng: -46.667414722338194, description: 'Ponto 7' },
        { lat: -23.595981159461207, lng: -46.66192963491876, description: 'Ponto 8' },
        { lat: -23.496517105522404, lng: -46.63169561946284, description: 'Ponto 9' },
        { lat: -23.58561273827321, lng: -46.60206375174043, description: 'Ponto 10' },
        { lat: -23.49596120332361, lng: -46.61108579624811, description: 'Ponto 11' },
        { lat: -23.42911597649735, lng: -46.713792052882894, description: 'Ponto 12' },
        { lat: -23.619689527715856, lng: -46.751845296194986, description: 'Ponto 13' },
        { lat: -23.582850355106327, lng: -46.544465209700085, description: 'Ponto 14' },
        { lat: -23.463673189713045, lng: -46.66040865558177, description: 'Ponto 15' }
      ];
    };
`;

  return (
    <div>
      <Nav tabs>
        <NavItem>
          <NavLink
            style={{ cursor: "pointer" }}
            className={classnames({ active: activeTab === "component" })}
            onClick={() => {
              setActiveTab("component");
            }}
          >
            Componente
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            style={{ cursor: "pointer" }}
            className={classnames({ active: activeTab === "codeBox" })}
            onClick={() => {
              setActiveTab("codeBox");
            }}
          >
            Código
          </NavLink>
        </NavItem>
      </Nav>
      <TabContent activeTab={activeTab} className="bg-white">
        <TabPane tabId="component">
          <Col sm="12">
            <div style={{ margin: 10, height: 550 }}>
              <ClusterMap coords={coords} zoomLevel={11} />
            </div>
          </Col>
        </TabPane>
        <TabPane tabId="codeBox">
          <Col sm="12">
            <CustomCode codeString={codeString} archiveName={'ClusterMap.js'} />
          </Col>
        </TabPane>
      </TabContent>
    </div>
  );
}

export default ComponentExample;